export const GROWTH_BOOK_URL = 'https://gbp.homebuddy.com';
